import { render, staticRenderFns } from "./PayphoneCheckout.vue?vue&type=template&id=fc3cdd08&scoped=true"
import script from "./PayphoneCheckout.vue?vue&type=script&lang=js"
export * from "./PayphoneCheckout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3cdd08",
  null
  
)

export default component.exports